import * as tslib_1 from "tslib";
import { map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { AuthService } from '../../auth/auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Business } from '../../business/models/business.model';
import { UserService } from './user.service';
import { AuthEventType } from '../../auth/models/auth-event.model';
var BusinessManagerService = /** @class */ (function () {
    function BusinessManagerService(_http, _auth, _errorHandler, userService) {
        var _this = this;
        this._http = _http;
        this._auth = _auth;
        this._errorHandler = _errorHandler;
        this.userService = userService;
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
    }
    BusinessManagerService.prototype._onAuthEvent = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!e) {
                            return [2 /*return*/];
                        }
                        _a = e.type;
                        switch (_a) {
                            case AuthEventType.SignIn: return [3 /*break*/, 1];
                            case AuthEventType.InvalidSignIn: return [3 /*break*/, 3];
                            case AuthEventType.SignOut: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 2:
                        _b.userInfo = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.userInfo = null;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Method creates a new business in the API Server with data from the NewBusinessInfo object passed in.
     * requires that user is authenticated, and is a flight-deck admin.
     * @param {NewBusinessInfo} {business} data sent to the server to make a new Business
     * @returns {Promise<Business>} API Server will respond with a new Business OBJ.
     */
    BusinessManagerService.prototype.createBusiness = function (business) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, BUSINESS, ERROR, _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, this._http.post(URL, business.serialize()).toPromise()];
                    case 2:
                        RESPONSE = _b.sent();
                        BUSINESS = Business.parse(RESPONSE);
                        if (!!BUSINESS) return [3 /*break*/, 3];
                        ERROR = new Error('API did not return valid business object');
                        this._errorHandler.handleError(ERROR);
                        throw ERROR;
                    case 3: return [4 /*yield*/, this._auth.login()];
                    case 4:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 5:
                        _a.userInfo = _b.sent();
                        return [2 /*return*/, BUSINESS];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        e_1 = _b.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * sends put request to api server to update the given business.
     * Method updates the API Server with data from the business object passed in.
     * Requires that user is authenticated.
     * @param {Business} {Business} will be serialized into JSON and sent to server.
     * @returns {Promise<Business>} API Server will respond with updated Business OBJ.
     */
    BusinessManagerService.prototype.updateBusiness = function (business) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, URL, RESPONSE, BUSINESS, ERROR, e_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userOwnsBusiness(business.id)];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + business.id;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.put(URL, business.serialize()).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        BUSINESS = Business.parse(RESPONSE);
                        if (!BUSINESS) {
                            ERROR = new Error('API did not return valid business object');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        else {
                            return [2 /*return*/, BUSINESS];
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        this._errorHandler.handleError(e_2);
                        throw e_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method stub for the API call to delete a business
     * @param {Business} {Business} will be serialized into JSON and sent to server.
     * @returns {Promise<boolean>} Returns true if the delete is successful, and false otherwise.
     */
    BusinessManagerService.prototype.deleteBusiness = function (business) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, URL, RESPONSE, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + business.id;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, true];
                    case 5:
                        e_3 = _b.sent();
                        this._errorHandler.handleError(e_3);
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method to call API to add a business manager
     * @param {Business} {business} the business to add the admin to.
     * @param {number} {recid} recid to be added as an admin.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessManagerService.prototype.addBusinessAdmin = function (business, recid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, paddedRecid, newAdmin, URL, RESPONSE, e_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        paddedRecid = (recid + '').padStart(8, '0');
                        newAdmin = {
                            recId: paddedRecid
                        };
                        URL = environment.airportsApiUrl + "/business/" + business.id + "/admin";
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.post(URL, newAdmin).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 5:
                        e_4 = _b.sent();
                        this._errorHandler.handleError(e_4);
                        return [2 /*return*/, e_4.error.message.toString()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method to call API to add a business manager
     * @param {Business} {business} the business to add the admin to.
     * @param {number} {recid} recid to be added as an admin.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessManagerService.prototype.updateBusinessAdmin = function (business, recid, primaryPoc, fboFeePoc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, paddedRecid, newAdmin, URL, RESPONSE, e_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        paddedRecid = (recid + '').padStart(8, '0');
                        newAdmin = {
                            recId: paddedRecid,
                            primaryPoc: primaryPoc,
                            fboFeePoc: fboFeePoc
                        };
                        URL = environment.airportsApiUrl + "/business/" + business.id + "/admin";
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.put(URL, newAdmin).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 5:
                        e_5 = _b.sent();
                        this._errorHandler.handleError(e_5);
                        return [2 /*return*/, e_5.error.message.toString()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method to call API to delete a business manager from a business
     * @param {Business} {business} the business to remove the admin from.
     * @param {number} {recid} recid to be deleted as an admin of this business.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessManagerService.prototype.deleteBusinessAdmin = function (business, recid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, paddedRecid, URL, RESPONSE, e_6;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        paddedRecid = (recid + '').padStart(8, '0');
                        URL = environment.airportsApiUrl + "/business/" + business.id + "/admin/" + paddedRecid;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 5:
                        e_6 = _b.sent();
                        this._errorHandler.handleError(e_6);
                        return [2 /*return*/, e_6.error.message.toString()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method to call API to add a business manager
     * @param {Airport} airport the business to add the admin to.
     * @param {number} recid to be added as an admin.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessManagerService.prototype.addAirportManager = function (airport, recid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, paddedRecid, newAdmin, URL, RESPONSE, e_7;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        paddedRecid = (recid + '').padStart(8, '0');
                        newAdmin = {
                            recId: paddedRecid
                        };
                        URL = environment.airportsApiUrl + "/airports/" + airport.airportId + "/admin";
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.post(URL, newAdmin).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 5:
                        e_7 = _b.sent();
                        this._errorHandler.handleError(e_7);
                        return [2 /*return*/, e_7.error.message.toString()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method to call API to delete a business manager from a business
     * @param {Airport} airport the business to remove the admin from.
     * @param {number} recid to be deleted as an admin of this business.
     * @returns {Promise<string>} Returns SUCCESS or error message for display to user.
     */
    BusinessManagerService.prototype.deleteAirportManager = function (airport, recid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ERROR, paddedRecid, URL, RESPONSE, e_8;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = !this._auth.authenticated || !this._auth.token || !this._auth.endUser;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.isFlightDeckAdmin];
                    case 1:
                        _a = !(_b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        paddedRecid = (recid + '').padStart(8, '0');
                        URL = environment.airportsApiUrl + "/airports/" + airport.airportId + "/admin/" + paddedRecid;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 4:
                        RESPONSE = _b.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 5:
                        e_8 = _b.sent();
                        this._errorHandler.handleError(e_8);
                        return [2 /*return*/, e_8.error.message.toString()];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method stub for the API call to add an associated airport to a business, must be authenticated to work
     * @param {Business} {business} Business to add the airport to
     * @param {Number} {airportId} ID of airport to be added to the business
     * @returns {Promise<Business>} Returns the updated Business if successful, and null otherwise
     */
    BusinessManagerService.prototype.addAssociatedAirport = function (business, airportId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, newAirport, URL, RESPONSE, e_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        newAirport = {
                            airportId: airportId
                        };
                        URL = environment.airportsApiUrl + "/business/" + business.id + "/airport";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.post(URL, newAirport).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        return [2 /*return*/, RESPONSE.toString()];
                    case 3:
                        e_9 = _a.sent();
                        this._errorHandler.handleError(e_9);
                        return [2 /*return*/, e_9.error.message.toString()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * method stub for the API call to remove an associated airport from a business, must be authenticated to work
     * @param {Business} {business} Business to add the airport to
     * @param {Number} {airportId} ID of airport to be removed from the business
     * @returns {Promise<Business>} Returns the updated Business if successful, and null otherwise
     */
    BusinessManagerService.prototype.removeAssociatedAirport = function (business, airportId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ERROR, URL, RESPONSE, e_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
                            ERROR = new Error('User not authorized');
                            this._errorHandler.handleError(ERROR);
                            throw ERROR;
                        }
                        URL = environment.airportsApiUrl + "/business/" + business.id + "/airport/" + airportId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.delete(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        return [2 /*return*/, RESPONSE.toString()];
                    case 3:
                        e_10 = _a.sent();
                        this._errorHandler.handleError(e_10);
                        return [2 /*return*/, e_10.error.message.toString()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Api Call to update the flight school object, must be authenticated to work
     * @param {Business} business the business object that will be updated
     * @returns {Observable<FlightSchool>} Returns the Flight School if successful, null otherwise
     */
    BusinessManagerService.prototype.updateFlightSchool = function (business) {
        if (!this._auth.authenticated || !this._auth.token || !this._auth.endUser) {
            var ERROR = new Error('User not authorized');
            this._errorHandler.handleError(ERROR);
            throw ERROR;
        }
        var URL = environment.airportsApiUrl + "/business/" + business.id + "/flightSchool";
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        try {
            return this._http.put(URL, business.serializeFlightSchool(), { headers: headers }).pipe(map(function (res) { return res; }));
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * Checks business id and if current user owns that business.
     * @param businessId id of business to check.
     * {Promise<boolean>} returns true if user is Business Owner or Flight Deck Admin
     */
    BusinessManagerService.prototype.userOwnsBusiness = function (businessId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, isBusinessManager, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _c.sent();
                        _c.label = 2;
                    case 2:
                        isBusinessManager = false;
                        if (businessId) {
                            isBusinessManager = (this.userInfo && this.userInfo.businessesManaged && this.userInfo.businessesManaged.indexOf(businessId) !== -1);
                        }
                        _b = isBusinessManager;
                        if (_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.isFlightDeckAdmin()];
                    case 3:
                        _b = (_c.sent());
                        _c.label = 4;
                    case 4: return [2 /*return*/, _b];
                }
            });
        });
    };
    /**
     * Checks business id and if current user owns that business.
     * @param airportId id of business to check.
     * {Promise<boolean>} returns true if user is Business Owner or Flight Deck Admin
     */
    BusinessManagerService.prototype.userManagesAirport = function (airportId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, isAirportManager, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _c.sent();
                        _c.label = 2;
                    case 2:
                        isAirportManager = false;
                        if (airportId) {
                            isAirportManager = (this.userInfo && this.userInfo.airportsManaged && this.userInfo.airportsManaged.indexOf(airportId) !== -1);
                        }
                        _b = isAirportManager;
                        if (_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.isFlightDeckAdmin()];
                    case 3:
                        _b = (_c.sent());
                        _c.label = 4;
                    case 4: return [2 /*return*/, _b];
                }
            });
        });
    };
    /**
     * Returns true if the current user is a flight deck admin, and false otherwise
     * **/
    BusinessManagerService.prototype.isFlightDeckAdmin = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, flightDeckAdmin;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        flightDeckAdmin = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'flightdeckadmin') {
                                    flightDeckAdmin = true;
                                }
                            });
                        }
                        return [2 /*return*/, flightDeckAdmin];
                }
            });
        });
    };
    /**
     * Returns true if the current user is a ycf ambassador, and false otherwise
     * **/
    BusinessManagerService.prototype.isAmbassador = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, ambassador;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        ambassador = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'ycfambassador') {
                                    ambassador = true;
                                }
                            });
                        }
                        return [2 /*return*/, ambassador];
                }
            });
        });
    };
    /**
     * Returns true if the current user is a regional manager, and false otherwise
     * **/
    BusinessManagerService.prototype.isRegionalManager = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, regionalManager;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        regionalManager = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'regionalmanager') {
                                    regionalManager = true;
                                }
                            });
                        }
                        return [2 /*return*/, regionalManager];
                }
            });
        });
    };
    BusinessManagerService.prototype.isSubscribedToCaribbeanGuide = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, caribbeanGuideSubscriber;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        caribbeanGuideSubscriber = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'caribbeanguide') {
                                    caribbeanGuideSubscriber = true;
                                }
                            });
                        }
                        return [2 /*return*/, caribbeanGuideSubscriber];
                }
            });
        });
    };
    BusinessManagerService.prototype.isSubscribedToBahamasGuide = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, bahamasGuideSubscriber;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        bahamasGuideSubscriber = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'bahamasguide') {
                                    bahamasGuideSubscriber = true;
                                }
                            });
                        }
                        return [2 /*return*/, bahamasGuideSubscriber];
                }
            });
        });
    };
    /**
     * Checks eventId and see if current user owns that event.
     * @param eventId id of event to check.
     * {Promise<boolean>} returns true if user is event Owner or Flight Deck Admin
     */
    BusinessManagerService.prototype.userOwnsEvent = function (eventRecid) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, isEventOwner, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _c.sent();
                        _c.label = 2;
                    case 2:
                        isEventOwner = false;
                        if (this.userInfo && eventRecid && eventRecid === +this.userInfo.masterCustomerId) {
                            isEventOwner = true;
                        }
                        _b = isEventOwner;
                        if (_b) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.isFlightDeckAdmin()];
                    case 3:
                        _b = (_c.sent());
                        _c.label = 4;
                    case 4: return [2 /*return*/, _b];
                }
            });
        });
    };
    /**
     * Returns true if the current user is an AOPA Member, and false otherwise
     * **/
    BusinessManagerService.prototype.isMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, member;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userInfo) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userService.getUserInfo()];
                    case 1:
                        _a.userInfo = _b.sent();
                        _b.label = 2;
                    case 2:
                        member = false;
                        if (this.userInfo &&
                            this.userInfo.relevantAceList &&
                            this.userInfo.relevantAceList.length > 0) {
                            this.userInfo.relevantAceList.forEach(function (ace) {
                                if (ace === 'member') {
                                    member = true;
                                }
                            });
                        }
                        return [2 /*return*/, member];
                }
            });
        });
    };
    return BusinessManagerService;
}());
export { BusinessManagerService };
